import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  // private dataSubject = new BehaviorSubject<GenericElement[]>([]);
  private childDataSubject = new BehaviorSubject<string>('');
  // private parentDataSubject = new BehaviorSubject<{ parentTable: string, parentId: string }>({ parentTable: '', parentId: '' });
  private sidenavDataSubject = new BehaviorSubject<any>(sidenav);
  // private parentTablePathDataSubject = new BehaviorSubject<{ parentTable: string, parentId: string }>({ parentTable: '', parentId: '' })

  // data$ = this.dataSubject.asObservable();
  childData$ = this.childDataSubject.asObservable();
  // parentData$ = this.parentDataSubject.asObservable();
  // parentTablePathData$ = this.parentTablePathDataSubject.asObservable();
  sidenavData$ = this.sidenavDataSubject.asObservable();

  // constructor() { }

  // setData(data: GenericElement[]) {
  //   this.dataSubject.next(data);
  // }

  // setDataChild(childData: string) {
  //   this.childDataSubject.next(childData);
  // }

  // setRouteEdit(parentTable: string, parentId: string) {
  //   const data = { parentTable, parentId }
  //   this.parentDataSubject.next(data);
  // }

  setSidenavData(data: any) {
    this.sidenavDataSubject.next(data);
  }

  // setDataParentTablePath(parentTable: string, parentId: string) {
  //   const data = { parentTable, parentId }
  //   this.parentTablePathDataSubject.next(data)
  // }

  private dataParaEnviar: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  setData(data: any): void {
    this.dataParaEnviar.next(data);
  }

  getData(): Observable<any> {
    return this.dataParaEnviar.asObservable();
  }
}

const sidenav = {
  inicio: { name: 'Inicio', path: '/home', child: '/home' },
  partido: { name: 'Partidos', path: '/partido', child: 'persona' },
  secciones: { name: 'Secciones', path: '/#', child: '/#' },
  partidoPaso: { name: 'Partido Paso', path: '/partidoPaso', child: 'listaInternaPaso', grandson: 'candidatoPaso' },
};

// {
//   "version": "1.0",
//   "urls": [
//     {
//       ... aca tiene que existir algo para definir las urls de este abmmc...
//       ... la del maestro, la de los n-detalles, alguna forma de mapeo con las columnas?
//     }
//   "columnas": [
//     {
//       "columna": "Nombre del Usuario",
//       "tooltip": "Ingrese el nombre completo del usuario",
//       "ruta": "usuario",
//       "mostrar": true,
//       "editarAlta": true,                                                 ej DNI una vez q se dio de alta, no
